import FrameworkContract from './framework-contract';

export default FrameworkContract;
